var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/path.js
// module id = IWN9
// module chunks = 0